import { Typography } from "../ui";
import React from "react";
import { typography } from "./settingsListDesign";

export type PageTitleProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
};

/**
 * Einheitliche Seitenüberschrift für Arbeits- und Einstellungsbereiche.
 * Immer gleiche Schriftgröße (Ant Design Title level 4), zentrale Stelle für spätere Anpassungen.
 */
export function PageTitle({ children, style, className }: PageTitleProps) {
  return (
    <Typography.Title
      level={4}
      style={{ margin: 0, fontSize: typography.title.level4.fontSize, lineHeight: typography.title.level4.lineHeight, fontWeight: typography.title.level4.fontWeight, ...style }}
      className={className}
    >
      {children}
    </Typography.Title>
  );
}
